<template>
  <b-table
    v-if="!isSkeleton"
    ref="manageRoleTable"
    :items="tableData"
    :fields="tableFields"
    :striped="true"
    responsive="sm"
    thead-class="tb-bg-gray"
    :class="['setting-table']"
    :tbody-tr-class="rowClass"
  >
    <!-- Header user information -->
    <template #head(info)="data">
      <div class="tw-flex tw-items-center">
        <button
          class="icon-select"
          type="button"
          data-cy="manage-role-table-select-all"
          @click="toggleSelectAll(!isSelectAll)"
        >
          <img
            v-show="isSelectAll"
            src="/img/elipse_selected_icon.svg"
            alt="eclipse_icon"
          />
          <img
            v-show="!isSelectAll"
            src="/img/elipse_icon.svg"
            alt="eclipse_icon"
          />
        </button>
        <span>{{ data.label.toUpperCase() }}</span>
      </div>
    </template>

    <!-- Cell User Data -->
    <template #cell(info)="data">
      <div class="tw-flex cell-name">
        <button
          class="icon-select"
          type="button"
          @click="toggleDetails(data.index)"
        >
          <img
            v-show="selected[data.index]?.isSelectedRow"
            src="/img/elipse_selected_icon.svg"
            alt="eclipse_icon"
          />
          <img
            v-show="!selected[data.index]?.isSelectedRow"
            src="/img/elipse_icon.svg"
            alt="eclipse_icon"
          />
        </button>
        <div class="name tw-flex tw-items-center">
          <img
            v-if="data.value?.imgSrc"
            :src="data.value?.imgSrc"
            alt="person_random"
          />
          <div class="information tw-flex tw-flex-none tw-flex-col tw-mr-12">
            <span class="name tw-font-semibold">{{
              `${data.value.firstName} ${data.value.lastName}`
            }}</span>
            <span class="email tw-text-xs grey-color">{{
              data.value.email
            }}</span>
          </div>
        </div>
      </div>
    </template>

    <!-- Cell Roles -->
    <template #cell(roles)="data">
      <div class="tw-flex">
        <div
          v-for="(role, index) in data.value"
          :key="index"
          class="cell-role tw-text-sm tw-font-medium tw-flex tw-items-center"
        >
          <span>{{ role.role }}</span>
          <svg
            v-if="role.isStart"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.71177 3.66897C9.6655 3.54707 9.58343 3.44202 9.47634 3.36765C9.36924 3.29328 9.24215 3.25307 9.11177 3.2523H6.52427L5.5951 0.6273C5.54991 0.505124 5.46838 0.399723 5.36149 0.325283C5.25459 0.250843 5.12745 0.210937 4.99718 0.210938C4.86692 0.210937 4.73978 0.250843 4.63288 0.325283C4.52598 0.399723 4.44445 0.505124 4.39927 0.6273L3.47427 3.24813H0.886767C0.754567 3.24585 0.624929 3.28474 0.515806 3.3594C0.406683 3.43406 0.323473 3.5408 0.277701 3.66484C0.231928 3.78889 0.225857 3.9241 0.260328 4.05174C0.2948 4.17939 0.368107 4.29316 0.4701 4.3773L2.66593 6.19397L1.74927 8.9523C1.70572 9.08093 1.70438 9.22011 1.74546 9.34955C1.78654 9.47899 1.86787 9.59194 1.97762 9.67192C2.08737 9.75191 2.21979 9.79476 2.3556 9.79423C2.4914 9.79369 2.62348 9.74981 2.7326 9.66897L4.99927 8.0023L7.26593 9.66897C7.37505 9.74981 7.50714 9.79369 7.64294 9.79423C7.77874 9.79476 7.91116 9.75191 8.02091 9.67192C8.13066 9.59194 8.212 9.47899 8.25307 9.34955C8.29415 9.22011 8.29282 9.08093 8.24927 8.9523L7.32843 6.19397L9.52843 4.37313C9.62669 4.28812 9.69683 4.17529 9.72956 4.04955C9.7623 3.92381 9.75609 3.7911 9.71177 3.66897ZM6.5451 5.7148C6.47606 5.76919 6.42598 5.84402 6.40203 5.92858C6.37809 6.01315 6.38149 6.10312 6.41177 6.18563L7.0826 8.21063C7.09048 8.2321 7.09107 8.25556 7.0843 8.2774C7.07752 8.29923 7.06375 8.31823 7.0451 8.33147C7.02642 8.34534 7.00378 8.35282 6.98052 8.35282C6.95725 8.35282 6.93461 8.34534 6.91593 8.33147L5.24927 7.1148C5.17366 7.06134 5.08353 7.03226 4.99093 7.03147C4.89825 7.03172 4.80796 7.06085 4.7326 7.1148L3.0826 8.33563C3.06392 8.3495 3.04128 8.35699 3.01802 8.35699C2.99475 8.35699 2.97211 8.3495 2.95343 8.33563C2.93388 8.32219 2.9195 8.30247 2.91268 8.27973C2.90586 8.257 2.90701 8.23262 2.91593 8.21063L3.58677 6.18563C3.61704 6.10312 3.62045 6.01315 3.5965 5.92858C3.57255 5.84402 3.52248 5.76919 3.45343 5.7148L1.78677 4.3148C1.76885 4.30101 1.75591 4.28176 1.74989 4.25996C1.74388 4.23816 1.74512 4.215 1.75343 4.19397C1.76031 4.17267 1.77362 4.15402 1.79153 4.14059C1.80943 4.12716 1.83106 4.11961 1.85343 4.11897H3.7826C3.87328 4.12014 3.96209 4.09311 4.03674 4.0416C4.11139 3.99009 4.16818 3.91666 4.19927 3.83147L4.89927 1.8398C4.90771 1.8191 4.92213 1.80139 4.94068 1.78892C4.95923 1.77645 4.98108 1.76979 5.00343 1.76979C5.02579 1.76979 5.04763 1.77645 5.06619 1.78892C5.08474 1.80139 5.09916 1.8191 5.1076 1.8398L5.8076 3.83147C5.83869 3.91666 5.89548 3.99009 5.97013 4.0416C6.04478 4.09311 6.13358 4.12014 6.22427 4.11897H8.1701C8.19304 4.11936 8.21531 4.12675 8.23393 4.14015C8.25255 4.15356 8.26662 4.17234 8.27427 4.19397C8.28258 4.215 8.28382 4.23816 8.27781 4.25996C8.2718 4.28176 8.25885 4.30101 8.24093 4.3148L6.5451 5.7148Z"
            />
          </svg>
        </div>
      </div>
    </template>
    <!-- Cell Actions button -->
    <template #cell(actions)="data">
      <ButtonShowMore
        :id-popover="'popover-btn-show-more-manage-role-table-' + data.index"
      >
        <template #default>
          <CustomDropDownItem
            :style="'normal'"
            :id-text="'app-settings-team-roles-more-modal-remove-user-1'"
            @click="() => $emit('delete:one_row', data.item)"
          />
        </template>
      </ButtonShowMore>
    </template>
  </b-table>
  <b-table
    v-else
    :items="[{}, {}, {}]"
    :fields="filedSkeleton"
    :striped="true"
    responsive="sm"
    thead-class="tb-bg-gray"
    :class="['setting-table']"
  >
    <template #head(info)="data">
      <div class="tw-flex tw-items-center">
        <button
          class="icon-select"
          type="button"
          @click="toggleSelectAll(!isSelectAll)"
        >
          <img
            v-show="isSelectAll"
            src="/img/elipse_selected_icon.svg"
            alt="eclipse_icon"
          />
          <img
            v-show="!isSelectAll"
            src="/img/elipse_icon.svg"
            alt="eclipse_icon"
          />
        </button>
        <span>{{ data.label.toUpperCase() }}</span>
      </div>
    </template>
  </b-table>
</template>

<script lang="ts" scoped>
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import ButtonShowMore from "@/components/common/setting/buttonShowMore.vue";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import store from "@/store";
import utilities from "@/utils/utilities";

@Component({
  emits: ["manage-user"],
  components: { ButtonShowMore, CustomDropDownItem },
})
export default class ManageRoleTable extends Vue {
  @Prop({ required: true }) readonly tableData: any[] = [];
  @Prop({ required: true }) readonly tableFields: any[] = [];
  @Prop({ default: false }) public reFresh!: boolean;
  @Prop({ default: false }) public isSkeleton!: boolean;

  public selected: any[] = [];
  public isSelectAll = false;

  @Watch("tableData")
  onTableDataChange() {
    this.selected = this.tableData;
  }

  getUiText(id: string, isArray = false) {
    return utilities.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }

  filedSkeleton = [
    {
      key: "info",
      label: "name",
      thClass: ["header-user"],
      trClass: "custom-global-skeleton",
    },
    {
      key: "homeOrgNameShort",
      label: "organisation",
      tdClass: "tw-w-3/4 custom-global-skeleton",
      trClass: ["header-organization"],
    },
  ];

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }
  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }

  toggleDetails(index) {
    this.$emit("select:one_row", [this.tableData[index]]);
    this.selected[index].isSelectedRow = !this.selected[index].isSelectedRow;

    if (this.selected[index].isSelectedRow) {
      this.tableData[index]._rowVariant = "item-selected";
    } else {
      this.tableData[index]._rowVariant = "tw-bg-transparent";
    }
  }

  toggleSelectAll(isSelectAll) {
    this.isSelectAll = isSelectAll;
    this.$emit("select:all_row", this.isSelectAll ? this.tableData : []);

    this.selected.forEach((item) => {
      item.isSelectedRow = this.isSelectAll;
    });

    this.tableData.forEach((item) => {
      if (this.isSelectAll) {
        item._rowVariant = "item-selected";
      } else {
        item._rowVariant = "tw-bg-transparent";
      }
    });
  }

  rowClass(item, type) {
    if (!item || type !== "row") return;
    if (item.age > 30) return "table-success";
  }

  @Watch("reFresh")
  onRefresh() {
    if (this.reFresh) {
      (this.$refs.manageRoleTable as any).refresh();
      this.selected = this.tableData;
    }
  }
}
</script>

<style lang="scss">
tbody tr td {
  background: #fff;
}

.b-table-selection-column {
  display: none !important;
}
.user-value {
  color: var(--ui-dark-grey, #878787);
  /* text/text-14_reg */
  font-family: Poppins;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
}
.selected {
  background-color: transparent !important;
}

.table-primary {
  background-color: transparent !important;
}

.setting-table {
  font-size: 13px;
  line-height: 30px;
  border-radius: 6px;
  display: block;
  overflow-x: auto;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
  background-color: #fff;

  table {
    border: 1px solid #eff0f1;
    border-radius: 6px;
    margin-bottom: 0;
  }

  @media (max-width: 480px) {
    .table {
      table-layout: auto;
    }
  }

  thead {
    font-size: 10px;
    background-color: #fcfcfd;
    text-transform: uppercase;
    tr {
      height: 56px;

      th {
        font-weight: 600;
        color: #878787 !important;
        border-top: 1px solid #eff0f1;
        border-bottom: 1px solid #eff0f1;
        padding: 17px 25px;
        white-space: nowrap;
        line-height: 100%;
        vertical-align: middle;
      }
    }
  }

  tbody {
    tr {
      height: 56px;
      td {
        padding: 18px 25px;
        border-top: 1px solid #eff0f1;
        vertical-align: middle;
        white-space: nowrap;
      }

      .td-actions {
        padding: 0;
      }
    }

    .cell-name {
      .name {
        img {
          width: 32px;
          height: 32px;
          margin-right: 15px;
          border-radius: 50%;
          border: 1px solid #eff0f1;
        }

        .information {
          span {
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .cell-org-name {
      .information-container {
        width: 100%;

        .information {
          width: 100%;

          .name {
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .cell-role {
      flex-direction: row;
      height: 34px;
      margin-right: 5px;
      border: 1px solid #eff0f1;
      border-radius: 100px;
      font-size: 11px;
      line-height: 14.3px;
      background-color: #ffffff;
      padding: 10px 13px;

      span {
        font-size: 11px;
        font-weight: 500;
        line-height: 110%;
      }

      svg {
        margin-left: 5px;
        fill: #231f20;
      }
    }

    .cell-status {
      padding: 3px 5px;
      height: 20px;
      border-radius: 4px;
      font-size: 11px;
      font-weight: 500;
    }

    .cell-last-active {
      color: #878787;
    }
  }

  .table-striped tbody tr:nth-of-type(odd) {
    background-color: #ffffff;
  }

  .name-header-text {
    color: #211f58;
    text-transform: uppercase;
  }

  .table-striped tbody tr:nth-of-type(even) {
    background-color: #fcfcfd;
  }

  button {
    border: none;
    background-color: transparent;
  }

  .information {
    .name {
      font-size: 13px;
      font-weight: 500;
      line-height: 20px;
      color: #231f20;
    }

    .email {
      line-height: 14px;
    }
  }

  .grey-color {
    color: #878787;
  }

  .active {
    background-color: #d9ede2;
    color: #01893d;
  }

  .invited {
    background-color: #e4f1ff;
    color: #0345bd;
  }

  .deactivated {
    background: var(
      --ui-background,
      linear-gradient(45deg, #f1f2f3 0%, #eeeff0 100%)
    );
    color: #b7b7b7;
  }

  .table-deactivated {
    color: #b7b7b7 !important;

    .name,
    .email,
    .cell-last-active {
      color: #b7b7b7 !important;
    }

    .cell-role {
      svg {
        fill: #b7b7b7 !important;
      }
    }
  }

  .icon-select {
    margin-right: 20px;
  }

  .table-item-selected {
    background-color: #f2f8ff !important;
  }

  .current-text {
    color: #387dff;
    text-transform: uppercase;
    border: 1px solid #eff0f1;
    border-radius: 2px;
    padding: 5px 6px;
    font-style: normal;
    font-weight: 700;
    font-size: 10px;
    line-height: 100%;
    letter-spacing: 1px;
    margin-left: 20px;
  }
}
</style>
